import PnmPhotoModalContainer from './PnmPhotoModalContainer';

export default PnmPhotoModalContainer;
